import { render, staticRenderFns } from "./followedUpTable.vue?vue&type=template&id=fa3e8de2&scoped=true&"
import script from "./followedUpTable.vue?vue&type=script&lang=js&"
export * from "./followedUpTable.vue?vue&type=script&lang=js&"
import style0 from "./followedUpTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./followedUpTable.vue?vue&type=style&index=1&id=fa3e8de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e8de2",
  null
  
)

export default component.exports